import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import WholesaleCompanyDialog from '../../companies/components/WholesaleCompanyDialog';
import sipInfoLayout from './layout.json';

class WholesaleSIPInfoList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      row: {},
      showCompanyDialog: false
    };

    this.onIconClicked = this.onIconClicked.bind( this );
    this.onHandleClose = this.onHandleClose.bind( this );
    this.onHandleSave = this.onHandleSave.bind( this );
  }

  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  onIconClicked( args ) {
    // This is needed in all tabs of the dialog because each tab gathers data
    // based on the Company_ID. The stored procs return the Company ID column
    // with different aliases...
    args.row.Company_ID = args.row.COMPANY_ID;
    args.row.Company = args.row.COMPANY_NAME;

    this.setState( {
      row: args.row,
      showCompanyDialog: true
    } );
  }

  onHandleClose( e ) {
    this.setState( {
      showCompanyDialog: false
    } );
  }

  onHandleSave( args ) {
    args.row.Company_ID = args.row.COMPANY_ID;
    args.row.Company = args.row.COMPANY_NAME;

    this.setState( {
      row: args.row
    } );
  }

  render() {
    return (
      <PageAuthorize groups={['Administrators', 'Operations', 'Management']}>
        <ListContainer
          id="WholesaleSipInfoList"
          layout={sipInfoLayout}
          selectedtab={4}
          row={this.state.row}
          onIconClicked={this.onIconClicked}
        />
        <WholesaleCompanyDialog
          show={this.state.showCompanyDialog}
          onClose={this.onHandleClose}
          onSave={this.onHandleSave}
          row={this.state.row}
          activeKey={3}
        />
      </PageAuthorize>
    );
  }
}

export default WholesaleSIPInfoList;



// WEBPACK FOOTER //
// ./src/content/wholesale/sipinfo/components/WholesaleSIPInfoList.js